/**
 * Format price to German currency format
 */

export function formatPrice(
  price: number | string | null,
  fractionDigits: number = 0
): string | null {
  if (price === null || price === undefined) return null;

  const safeDigits = Number.isFinite(fractionDigits)
    ? Math.min(Math.max(Math.floor(fractionDigits), 0), 20)
    : 0;

  return Number(price).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: safeDigits,
    maximumFractionDigits: safeDigits,
  });
}
